<template>
  <a-modal :title="isInvoiceType?'请确认开票':'请确认到账'"
           :width="1000"
           :visible="visible"
           :destroyOnClose="true"
           :maskClosable="false"
           :confirm-loading="confirmLoading"
           @ok="onSave"
           @cancel="$emit('cancel')">
    <div>
      <a-card>
        <a-form-model ref="form" :model="fwfModel" :rules="rules" class="pick-100">
          <a-row type="flex" justify="space-between" class="form-input about">

            <template v-if="isInvoiceType">
              <table class="fx-form-view mb-3">
                <tr>
                  <th>采购人名称</th>
                  <td>
                    {{ fwfModel.wtrdwmc }}
                  </td>
                  <th>信用代码（税号）</th>
                  <td>
                    {{ fwfModel.wtrtyxydm }}
                  </td>
                </tr>
                <tr>
                  <th>地址</th>
                  <td>
                    {{ fwfModel.wtrdwdz }}
                  </td>
                  <th>电话号码</th>
                  <td>
                    {{ fwfModel.wtrbgdh }}
                  </td>
                </tr>
                <tr>
                  <th>开户银行</th>
                  <td>
                    {{ fwfModel.bank }}
                  </td>
                  <th>银行账号</th>
                  <td>
                    {{ fwfModel.bankAccount }}
                  </td>
                </tr>
              </table>
              <a-col :span="11">
                <a-form-model-item label="开票时间" prop="invoiceDate">
                  <a-date-picker format="YYYY年MM月DD日" placeholder="选择开票时间"
                                 v-model="fwfModel.invoiceDate"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item label="开票类型" prop="invoiceType">
                  <dict-cascader dictKey="FWF.KPLX" placeholder="请选择开票类型" v-model="fwfModel.invoiceType"
                  />
                </a-form-model-item>
              </a-col>
            </template>
            <a-col :span="11" v-else>
              <a-form-model-item label="到账时间" prop="creditedDate">
                <a-date-picker format="YYYY年MM月DD日" placeholder="选择到账时间"
                               v-model="fwfModel.creditedDate"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    </div>
  </a-modal>
</template>
<script>
import { PageView } from '@/layouts'
import qs from 'qs'
import DictCascader from '../../../components/dict/DictCascader'
import moment from 'moment'
import { UpdateBidXqdcFwf } from '@/views/demandsurveybid/servicefee/api/FeeRequest'

const rules = {
  creditedDate: [{ required: true, message: '选择到账时间', trigger: 'change' }],
  invoiceDate: [{ required: true, message: '选择开票时间', trigger: 'change' }],
  invoiceType: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
}
export default {
  name: 'SurveyDzAndFwfModel',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PageView,
    DictCascader
  },
  data () {
    return {
      rules,
      confirmLoading: false,
      fwfModel: {
        submitType: undefined,//操作类型 0 是到账 1是开票
      },
      operationType: undefined,
    }
  },
  computed: {
    isInvoiceType () {
      return this.fwfModel.submitType === '1'
    },
  },
  created () {
  },
  methods: {
    initData (fwfModel, type) {
      this.fwfModel = { ...fwfModel }
      this.fwfModel.creditedDate = fwfModel.creditedDate && moment(fwfModel.creditedDate)
      this.fwfModel.invoiceDate = fwfModel.invoiceDate && moment(fwfModel.invoiceDate)
      this.fwfModel.submitType = type
    },
    onSave () {
      let that = this
      that.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          that.confirmLoading = true
          let data = { ...that.fwfModel }
          data.creditedDate = data.creditedDate && data.creditedDate.format('YYYY-MM-DD HH:mm')
          data.invoiceDate = data.invoiceDate && data.invoiceDate.format('YYYY-MM-DD HH:mm')
          if (data.submitType === '0') {
            data.creditedFlag = '1'
          } else {
            data.invoiceFlag = '1'
          }
          let res = await UpdateBidXqdcFwf(data)
          if (res.code === 200) {
            that.$message.success('操作成功')
            that.$emit('success')
          } else {
            that.$message.error('操作失败')
          }
        } catch (e) {
          that.$message.error(e.message)
        } finally {
          that.confirmLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
